import { haack, powerNose, ellipseNose, approximateHaack, approximateEllipse, approximatePower } from './nose-cones.js'
import estimateAeroCoefficients from './intlift.js'
import trajectory from './trajectory.ts'
import estimatePenetration from './penetration'
import estimateVelocity from './estimateVelocity'

let transStartI
let transEndI
let M = []
for (let i = 0.5; i < 3.0; i += .1) {
  M.push(parseFloat(i.toFixed(2)))
  if (i >= 1 && !transStartI) transStartI = M.length
  if (i >= 1.2 && !transEndI) transEndI = M.length
}
let allM = M
//allM = [ 0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.725, 0.75, 0.775, 0.8, 0.825, 0.85, 0.875, 0.9, 0.925, 0.95, 0.975, 1, 1.025, 1.05, 1.075, 1.1, 1.125, 1.15, 1.2, 1.25, 1.3, 1.35, 1.4, 1.5, 1.55, 1.6, 1.65, 1.7, 1.75, 1.8, 1.85, 1.9, 1.95, 2, 2.05, 2.1, 2.15, 2.2, 2.25, 2.3, 2.35, 2.4, 2.45, 2.5, 2.55, 2.6, 2.65, 2.7, 2.75, 2.8, 2.85, 2.9, 2.95, 3, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4, 4.2, 4.4, 4.6, 4.8, 5 ]

let G7

let G7scale = M.map(() => 1)
let smoothG7 = M.map(() => 1)
let G7results = calculateDrag({
  grains: 7000,
  diameter: 0.99,
  bearingSurfaceLength: 1.50,
  jacketThickness: 0,
  noseLength: 2.18,
  noseCavity: 0,
  noseType: 'secant',
  rtr: .95,
  baseCavityDiameter: 0,
  baseCavityLength: 0,
  power: null,
  haackC: null,
  boattailLength: .6,
  baseDiameter: .837,
  meplat: 0.120,
  drivingBandDiameter: 0,
  drivingBands: 0,
  hybridRadius: 0,
  velocity: 2800,
  grainsPerCubicIn: 2622
})
G7 = [ ...G7results.C1 ]
const actualG7 = [ 0.1198, 0.1197, 0.1196, 0.1194, 0.1193, 0.1194, 0.1194, 0.1194, 0.1193, 0.1193, 0.1194, 0.1193, 0.1194, 0.1197, 0.1202, 0.1207, 0.1215, 0.1226, 0.1242, 0.1266, 0.1306, 0.1368, 0.1464, 0.1660, 0.2054, 0.2993, 0.3803, 0.4015, 0.4043, 0.4034, 0.4014, 0.3987, 0.3955, 0.3884, 0.3810, 0.3732, 0.3657, 0.3580, 0.3440, 0.3376, 0.3315, 0.3260, 0.3209, 0.3160, 0.3117, 0.3078, 0.3042, 0.3010, 0.2980, 0.2951, 0.2922, 0.2892, 0.2864, 0.2835, 0.2807, 0.2779, 0.2752, 0.2725, 0.2697, 0.2670, 0.2643, 0.2615, 0.2588, 0.2561, 0.2533, 0.2506, 0.2479, 0.2451, 0.2424, 0.2368, 0.2313, 0.2258, 0.2205, 0.2154, 0.2106, 0.2060, 0.2017, 0.1975, 0.1935, 0.1861, 0.1793, 0.1730, 0.1672, 0.1618 ]
const actualG7_M = [ 0.000, 0.050, 0.100, 0.150, 0.200, 0.250, 0.300, 0.350, 0.400, 0.450, 0.500, 0.550, 0.600, 0.650, 0.700, 0.725, 0.750, 0.775, 0.800, 0.825, 0.850, 0.875, 0.900, 0.925, 0.950, 0.975, 1.000, 1.025, 1.050, 1.075, 1.100, 1.125, 1.150, 1.200, 1.250, 1.300, 1.350, 1.400, 1.500, 1.550, 1.600, 1.650, 1.700, 1.750, 1.800, 1.850, 1.900, 1.950, 2.000, 2.050, 2.100, 2.150, 2.200, 2.250, 2.300, 2.350, 2.400, 2.450, 2.500, 2.550, 2.600, 2.650, 2.700, 2.750, 2.800, 2.850, 2.900, 2.950, 3.000, 3.100, 3.200, 3.300, 3.400, 3.500, 3.600, 3.700, 3.800, 3.900, 4.000, 4.200, 4.400, 4.600, 4.800, 5.000 ]
G7scale = getG7ScalingFactors(M, G7)
//G7results = calculateDrag(7000, 0.99, 1.50, 2.18, 'secant', 0.95, .6, .837, 0.120, 0, 0, 0, 2622)
smoothG7 = G7.map((v, i) => v / G7scale[i])

// all args in inches
export default function calculateDrag(options) {
  let {
    grains,
    diameter,
    bearingSurfaceLength,
    jacketThickness,
    noseLength,
    noseCavity,
    noseType,
    rtr,
    baseCavityDiameter,
    baseCavityLength,
    tipLength,
    tipStemDiameter,
    tipStemLength,
    tipCoreLength,
    power,
    haackC,
    boattailLength,
    baseDiameter,
    meplat,
    drivingBandDiameter,
    drivingBands,
    hybridRadius,
    grainsPerCubicIn,
    targetRange,
    altitude,
    velocity,
    baseWeight,
    sg,
    M,
    constraints
  } = options
  tipCoreLength = tipCoreLength || 0
  tipLength = tipLength || 0
  tipStemDiameter = tipStemDiameter || 0
  tipStemLength = tipStemLength || 0
  baseCavityDiameter = baseCavityDiameter || 0
  baseCavityLength = baseCavityLength || 0
  drivingBandDiameter = drivingBandDiameter || 0
  drivingBands = drivingBands || 0
  velocity = velocity || 2800
  //console.log(options)
  if (!constraints) constraints = {}
  //console.log({ velocity })
  if (!M) M = allM
  if (jacketThickness <= 0) {
    jacketThickness = 0
    noseCavity = 0
  }
  if (baseCavityDiameter > baseDiameter) {
    baseCavityDiameter = baseDiameter
  }
  let meplatFit = meplat
  if (noseType === 'haack') {
    const haackParams = approximateHaack(diameter, noseLength, meplat, haackC)
    rtr = haackParams.rtr
    meplatFit = haackParams.meplat
  } else if (noseType === 'elliptical') {
    const ellParams = approximateEllipse(diameter, noseLength)
    rtr = ellParams.rtr
    meplatFit = ellParams.meplat
  } else if (noseType === 'power') {
    const powerParams = approximatePower(diameter, noseLength, power)
    rtr = powerParams.rtr
    meplatFit = powerParams.meplat
  }
  const length = boattailLength + bearingSurfaceLength + noseLength
  const weights = calculateWeight({
    diameter,
    length,
    jacketThickness,
    noseLength,
    noseCavity,
    noseType,
    rtr,
    baseCavityDiameter,
    baseCavityLength,
    tipLength,
    tipStemDiameter,
    tipStemLength,
    tipCoreLength,
    power,
    haackC,
    bearingSurfaceLength,
    boattailLength,
    baseDiameter,
    meplat,
    drivingBands,
    drivingBandDiameter,
    grainsPerCubicIn
  })
  if (options.cgPercent) {
    weights.CG = weights.CG - length * options.cgPercent
  }
  if (tipStemDiameter > weights.maxTipDiameter) {
    tipStemDiameter = weights.maxTipDiameter - .03
  }
  if (!grains) {
    grains = weights.grains
  }
  if (velocity && baseWeight) {
    velocity = estimateVelocity(grains, baseWeight, velocity, true)
    velocity = Math.round(velocity)
    if (constraints.velocity && (velocity < constraints.velocity.min || velocity > constraints.velocity.max)) {
      return null
    }
  }
  if (constraints.weight && (grains < constraints.weight.min || grains > constraints.weight.max)) {
    return null
  }
  const transitionAngle = Math.atan(weights.centerX / weights.centerY) * 180 / Math.PI
  if (constraints.transitionAngle && (transitionAngle < constraints.transitionAngle.min || transitionAngle > constraints.transitionAngle.max)) {
    return null
  }
  const millerTwistRate = neededTwist(diameter, length, grains, velocity / 1245, altitude, sg)
  const mcdragTwistRate = mcdrag_twist(velocity / 1245, diameter, bearingSurfaceLength, noseLength, rtr, boattailLength, baseDiameter, meplatFit, grainsPerCubicIn)
  //let twistRate = Math.min(millerTwistRate, mcdragTwistRate)
  let twistRate

  let coeffValues = estimateAeroCoefficients({
    Ix: weights.Ix,
    Iy: weights.Iy,
    boattailLength,
    bearingSurfaceLength,
    noseLength,
    cg: weights.CG,
    diameter,
    grains: weights.grains,
    rtr,
    baseDiameter,
    meplat: meplatFit
  }, [ velocity / 1245 ])
  const Cma = coeffValues.Cma[0]

  for (let tw = 30; tw >= 1; tw -= .1) {
    const sg = getStaticStability(diameter, tw, Cma, weights.Iy, weights.Ix, velocity, altitude)
    if (sg >= 1.5) {
      twistRate = tw
      break
    }
  }
  const SgVsTwist = []
  for (let twistRate = 1; twistRate <= 30; twistRate += .1) {
    const sg = getStaticStability(diameter, twistRate, Cma, weights.Iy, weights.Ix, velocity, altitude)
    if (sg > .5 && sg < 3) {
      SgVsTwist.push({
        sg,
        twistRate: twistRate.toFixed(1),
        unstable: [ 0, 1, sg < 1 ],
        marginal: [ 1, 1.5, sg >= 1 && sg < 1.5 ],
        stable: [ 1.5, 3, sg >= 1.5 ],
      })
    }
  }
  if (constraints.twist && (twistRate < constraints.twist.min || twistRate > constraints.twist.max)) {
    return null
  }
  const radiusInches = weights.radiusInches
  const radiusCalibers = weights.radiusCalibers
  const boattailAngle = Math.atan2((diameter - baseDiameter) / 2, boattailLength) * 180 / Math.PI
  let SD = (grains / 7000) / ((diameter + drivingBandDiameter) * (diameter + drivingBandDiameter))

  if (constraints.boattailAngle && (boattailAngle < constraints.boattailAngle.min || boattailAngle > constraints.boattailAngle.max)) {
    return null
  }

  // MCDRAG, BY R. L. MCCOY.
  // DEC. 1974 DRAG COEFFICIENT ESTIMATE FOR AN AXISYMMETRIC PROJECTILE.
  // INPUT QUANTITIES ARE REFERENCE DIAMETER (MM), TOTAL LENGTH (CAL),
  // NOSE LENGTH (CAL), RATIO OF TANGENT RADIUS TO ACTUAL NOSE RADIUS (RT/R),
  // BOATTAIL LENGTH (CAL), BASE DIAMTER (CAL), MEPLAT DIAMTER (CAL),
  // ROTATING BAND DIAMTER (CAL), OPTIONAL CENTER OF GRAVITY (CAL, NOSE),
  // AND BOUNDARY LAYER CODE (L/L, L/T, OR T/T), FOLLOWED BY PROJECTILE
  // IDENTIFICATION INFORMATION.
  // CD0  CDH  CDSF  CDBND  CDBT  CDB
  // C1   C2   C3    C4     C5    C6
  let C1 = [] // CD0
  let C2 = [] // nose
  let C3 = [] // surface
  let C4 = [] // driving band
  let C5 = [] // boattail
  let C6 = [] // base
  let P1 = []
  let FF = []
  let BC = []
  let TW = []

  let
  A1, A2, A11, A12,
  B, B2, B3, B4,
  C7, C8, C9, C10, C11, C12, C13, C14, C15, C16, C17, C18,
  D1, D2, D3, D4, D5,
  E1, E2, E3,
  K$,
  L1, L2, L3,
  M2,
  P2, P4, P5,
  R1, R2, R3, R4, R5,
  S1, S2, S3, S4,
  T1, T2, T3,
  X1, X2, X3,
  Z

  D1 = diameter * 25.4                             // projectile reference diamter (mm)
  L1 = length / diameter                           // total projectile length (calibers)
  L2 = noseLength / diameter                       // nose length (calibers)
  R1 = rtr                                         // rt/r (headshape parameter)
  L3 = boattailLength / diameter                   // boattail length (calibers)
  D2 = baseDiameter / diameter                     // base diamter (calibers)
  D3 = meplatFit / diameter                        // meplat diameter (calibers)
  D4 = (diameter + drivingBandDiameter) / diameter // rotating band diamter (calibers)
  if (R1 === 0) R1 = 0.01

  // FOR ALL LAMINAR BOUNDARY LAYER, CODE = L/L
  // FOR LAMINAR NOSE, TURBULENT AFTERBODY, CODE = L/T
  // FOR ALL TURBULENT BOUNDARY LAYER, CODE = T/T
  K$ = 'L/T'

  for (let I = 0; I < M.length; ++I) {
    //if (M > 1.2) {
    //  K$ = 'L/L'
    //} else if (M > .8) {
    //  K$ = 'L/T'
    //} else {
    //  K$ = 'T/T'
    //}
    T1 = (1 - D3) / L2
    M2 = Math.pow(M[I], 2)
    R2 = 23296.3 * M[I] * L1 * D1
    R3 = .4343 * (Math.log(R2))
    C7 = (1.328 / Math.sqrt(R2)) * Math.pow(1 + .12 * M2, -.12)
    C8 = (.455 / Math.pow(R3, 2.58)) * Math.pow(1 + .21 * M2, -.32)
    D5 = 1 + ((.333 + (.02 / Math.pow(L2, 2))) * R1)
    S1 = 1.5708 * L2 * D5 * (1 + (1 / (8 * Math.pow(L2, 2))))
    S2 = 3.1416 * (L1 - L2)
    S3 = S1 + S2

    if (K$ === "L/L") {
      C9 = 1.2732 * S3 * C7
      C10 = C9
    }

    if (K$ === "L/T") {
      C9 = 1.2732 * S3 * C7
      C10 = 1.2732 * S3 * C8
    }

    if (K$ === "T/T") {
      C9 = 1.2732 * S3 * C8
      C10 = C9
    }

    C3[I] = (C9 * S1 + C10 * S2) / S3
    C15 = (M2 - 1) / (2.4 * M2)

    if (M[I] <= 1) {
      P5 = Math.pow(1 + .2 * M2, 3.5)
    } else {
      P5 = Math.pow(1.2 * M2, 3.5) * Math.pow(6 / (7 * M2 - 1), 2.5)
    }

    C16 = (1.122 * (P5 - 1) * Math.pow(D3, 2)) / M2

    if (M[I] <= .91) {
      C18 = 0
    } else if (M[I] >= 1.41) {
      C18 = .85 * C16
    } else {
      C18 = (.254 + 2.88 * C15) * C16
    }


    if (M[I] < 1) {
      P2 = 1 / (1 + .1875 * M2 + .0531 * Math.pow(M2, 2))
    } else {
      P2 = 1 / (1 + .2477 * M2 + .0345 * Math.pow(M2, 2))
    }


    P4 = (1 + 9.000001E-02 * M2 * (1 - Math.exp(L2 - L1))) * (1 + .25 * M2 * (1 - D2))
    P1[I] = P2 * P4

    if (P1[I] >= 0) {
      C6[I] = (1.4286 * (1 - P1[I]) * Math.pow(D2, 2)) / M2
    } else {
      P1[I] = 0
      C6[I] = 0
    }

    if (M[I] < .95) {
      C4[I] = Math.pow(M[I], 12.5) * (D4 - 1)
    } else {
      C4[I] = (.21 + .28 / M2) * (D4 - 1)
    }

    // SUBSONIC AND TRANSONIC SPEEDS
    if (M[I] > 1) {
      // SUPERSONIC SPEEDS
      B2 = M2 - 1
      B = Math.sqrt(B2)
      Z = B
      S4 = 1 + .368 * Math.pow(T1, 1.85)
      if (M[I] < S4) {
        Z = Math.sqrt(Math.pow(S4, 2) - 1)
      }
      C11 = .7156 - .5313 * R1 + .595 * Math.pow(R1, 2)
      C12 = .0796 + .0779 * R1
      C13 = 1.587 + .049 * R1
      C14 = .1122 + .1658 * R1
      R4 = 1 / Math.pow(Z, 2)
      C17 = (C11 - C12 * Math.pow(T1, 2)) * R4 * Math.pow(T1 * Z, C13 + C14 * T1)
      C2[I] = C17 + C18
      if (L3 <= 0) {
        C5[I] = 0
      } else {
        T2 = (1 - D2) / (2 * L3)
        if (M[I] <= 1.1) {
          T3 = 2 * Math.pow(T2, 2) + Math.pow(T2, 3)
          E1 = Math.exp((-2) * L3)
          B4 = 1 - E1 + 2 * T2 * ((E1 * (L3 + .5)) - .5)
          C5[I] = 2 * T3 * B4 * (1.774 - 9.3 * C15)
        } else {
          B3 = .85 / B
          A12 = (5 * T1) / (6 * B) + Math.pow(.5 * T1, 2) - (.7435 / M2) * Math.pow(T1 * M[I], 1.6)
          A11 = (1 - ((.6 * R1) / M[I])) * A12
          E2 = Math.exp(((-1.1952) / M[I]) * (L1 - L2 - L3))
          X3 = ((2.4 * Math.pow(M2, 2) - 4 * B2) * Math.pow(T2, 2)) / (2 * Math.pow(B2, 2))
          A1 = A11 * E2 - X3 + ((2 * T2) / B)
          R5 = 1 / B3
          E3 = Math.exp((-B3) * L3)
          A2 = 1 - E3 + (2 * T2 * (E3 * (L3 + R5) - R5))
          C5[I] = 4 * A1 * T2 * A2 * R5
        }
      }
    } else {
      if (L3 <= 0) {
        C5[I] = 0
      } else {
        if (M[I] <= .85) {
          C5[I] = 0
        } else {
          T2 = (1 - D2) / (2 * L3)
          T3 = 2 * Math.pow(T2, 2) + Math.pow(T2, 3)
          E1 = Math.exp((-2) * L3)
          B4 = 1 - E1 + 2 * T2 * ((E1 * (L3 + .5)) - .5)
          C5[I] = 2 * T3 * B4 * (1 / (.564 + 1250 * Math.pow(C15, 2)))
        }
      }

      X2 = Math.pow(1 + .552 * Math.pow(T1, .8), -.5)
      if (M[I] <= X2) {
        C17 = 0
      } else {
        C17 = .368 * Math.pow(T1, 1.8) + 1.6 * T1 * C15
      }
      C2[I] = C17 + C18
    }

    if (drivingBands > 1) {
      C4[I] = Math.pow(drivingBands, 1.3) * C4[I] // multiplying C4 is not in the original program, but seems to work
    }
    if (C2[I] > 1) C2[I] = 1
    if (C3[I] > 1) C3[I] = 1
    if (C4[I] > 1) C4[I] = 1
    if (C5[I] > 1) C5[I] = 1
    if (C6[I] > 1) C6[I] = 1
    C1[I] = C2[I] + C3[I] + C4[I] + C5[I] + C6[I]
    if (G7) FF[I] = C1[I] / G7[I]
    BC[I] = SD / FF[I]
  }

  // do some smoothing on boattail drag
  for (let I = transStartI + 1; I < transEndI; ++I) {
    const r = (I - transStartI) / (transEndI - transStartI)
    C5[I] = C5[transStartI] * (1 - r) + C5[transEndI] * r
    C1[I] = C2[I] + C3[I] + C4[I] + C5[I] + C6[I]
    if (G7) FF[I] = C1[I] / G7[I]
    let SD = (grains / 7000) / ((diameter + drivingBandDiameter) * (diameter + drivingBandDiameter))
    BC[I] = SD / FF[I]
  }

  let avgBC = 0
  let superBC = 0
  let transBC = 0
  let subBC = 0
  let avgCD = 0
  let superCD = 0
  let transCD = 0
  let subCD = 0
  let avgFF = 0
  let superFF = 0
  let transFF = 0
  let subFF = 0
  let count = 0
  let superCount = 0
  let transCount = 0
  let subCount = 0
  for (let I = 0; I < M.length; ++I) {
    if ([ 1.5, 2.0, 2.5, 3.0 ].includes(M[I])) {
      ++superCount
      superBC += BC[I]
      superCD += C1[I]
      superFF += FF[I]
    }
    if (M[I] >= 0.8 && M[I] <= 1.2) {
      ++transCount
      transBC += BC[I]
      transCD += C1[I]
      transFF += FF[I]
    }
    if (M[I] <= 0.8) {
      ++subCount
      subBC += BC[I]
      subCD += C1[I]
      subFF += FF[I]
    }
    if (BC[I] < 1 && FF[I] > 0) {
      ++count
      avgBC += BC[I]
      avgCD += C1[I]
      avgFF += FF[I]
    }
  }
  avgBC /= count
  avgCD /= count
  avgFF /= count
  superBC /= superCount
  superCD /= superCount
  superFF /= superCount
  transBC /= transCount
  transCD /= transCount
  transFF /= transCount
  subBC /= subCount
  subCD /= subCount
  subFF /= subCount

  for (let i = 0; i < M.length; ++i) {
    TW.push(neededTwist(diameter, length, grains, M[i], altitude, sg))
  }

  let error
  if (L2 < 1) {
    error = "NOSE TOO SHORT.  CDH IS TOO HIGH AT TRANSONIC AND SUPERSONIC SPEEDS."
  }
  if (D3 > .5) {
    error = "NOSE TOO BLUNT.  CDH IS TOO HIGH AT TRANSONIC AND SUPERSONIC SPEEDS."
  }
  if (L3 >= 1.5) {
    error = "BOATTAIL TOO LONG. CDBT AND CDB MAY BE INCORRECT."
  }
  if (D2 < .65) {
    error = "BOATTAIL TOO STEEP.  CDBT AND CDB MAY BE INCORRECT."
  } else if (D2 > 1.35) {
    error = "CONICAL FLARE TAIL TOO STEEP.  CDBT AND CDB MAY BE INCORRECT."
  }

  let hybrid
  if (hybridRadius > 0 && rtr < 1) {
    const hcy = diameter / 2 - hybridRadius
    const hcx = weights.centerX + Math.sqrt(Math.pow(radiusInches - hybridRadius, 2) - Math.pow(weights.centerY - hcy, 2))
    // https://www.geeksforgeeks.org/find-points-at-a-given-distance-on-a-line-of-given-slope/
    const slope = (weights.centerY - hcy) / (weights.centerX - hcx)
    const tx = hcx + hybridRadius * Math.sqrt(1 / (1 + slope * slope))
    const ty = hcy + slope * hybridRadius * Math.sqrt(1 / (1 + slope * slope))
    const arc = Math.atan2(tx - hcx, ty - hcy)
    hybrid = {
      radius: hybridRadius,
      cx: hcx,
      cy: hcy,
      x1: hcx,
      y1: diameter / 2,
      x2: tx,
      y2: ty,
      arc
    }
  }

  C1 = C1.map((v, i) => v / G7scale[i])
  // TODO: we could do some smoothing here
  //const kernelSize = 5
  //const sigma = 3
  //BC = gaussianFilterWithPadding(BC, kernelSize, sigma);
  //if (G7.length) {
  //  for (let i = 0; i < M.length; ++i) {
  //    C1[i] = (SD / BC[i]) * G7[i]
  //  }
  //}

  const dragfunc = m => {
    if (m <= .5) return C1[0]
    if (m >= 3) return C1[50]
    const i = Math.floor((m - .5) / .01)
    const j = Math.ceil((m - .5) / .01)
    if (j <= 0) return C1[0]
    if (i >= C1.length) return C1[C1.length - 1]
    const ci = C1[i]
    const cj = C1[j]
    const mi = M[i]
    const mj = M[j]
    const x = m - mi
    const y = mj - mi
    const p = x  / y
    const c = ci + (cj - ci) * p
    return c
  }
  coeffValues = estimateAeroCoefficients({
    Ix: weights.Ix,
    Iy: weights.Iy,
    grains: weights.grains,
    boattailLength,
    bearingSurfaceLength,
    noseLength,
    boattailAngle,
    cg: weights.CG,
    diameter,
    rtr,
    baseDiameter,
    meplat: meplatFit
  }, M, C1)

  const kernelSize = 15
  const sigma = 3
  coeffValues.Cmq = gaussianFilterWithPadding(coeffValues.Cmq, kernelSize, sigma);
  coeffValues.Cma = gaussianFilterWithPadding(coeffValues.Cma, kernelSize, sigma);
  coeffValues.Cla = gaussianFilterWithPadding(coeffValues.Cla, kernelSize, sigma);
  coeffValues.Cna = gaussianFilterWithPadding(coeffValues.Cna, kernelSize, sigma);
  coeffValues.Cna = gaussianFilterWithPadding(coeffValues.Cna, kernelSize, sigma);
  coeffValues.Cda2 = gaussianFilterWithPadding(coeffValues.Cda2, kernelSize, sigma);

  let coeffs
  coeffValues.Sg = []
  coeffValues.Sd = []
  coeffValues.minSg = []
  coeffValues.stable = []
  for (let i = 0; i < M.length; ++i) {
    const Sg = getStaticStability(diameter, twistRate, Cma, weights.Iy, weights.Ix, M[i] * 1245, altitude)
    const meterDiameter = diameter * 2.54
    const grams = 0.06479891 * grains
    const { Sd, stable, minSg } = calculateDynamicStability(
      weights.Ix,
      weights.Iy,
      grams,
      meterDiameter,
      coeffValues.Cla[i],
      coeffValues.Cd[i],
      coeffValues.Cnpa[i],
      coeffValues.Cmq[i],
      Sg
    )
    coeffValues.Sd[i] = Sd
    coeffValues.minSg[i] = minSg
    coeffValues.stable[i] = stable ? 1 : 0
    if (!coeffs && M[i] >= velocity / 1245) {
      coeffs = {}
      Object.keys(coeffValues).forEach(k => {
        coeffs[k] = coeffValues[k][i]
      })
    }
  }
  const deltaCg = 0
  const tubeAngle = calculateInBoreAngle(diameter, bearingSurfaceLength, diameter + .001)
  try {
    coeffs.thetaJ = jumpEquation(
      coeffs.Cna,
      coeffs.Cd,
      coeffs.Cma,
      weights.Iy,
      weights.Ix,
      grains,
      diameter,
      velocity,
      1, // tubeAngle,
      twistRate,
      deltaCg
    )
    const jump = Math.tan(coeffs.thetaJ) * 100 * 3 * 12
    coeffs.jump = jump
  } catch (e) {
  }

  let windMOA
  let dropMOA
  let penetration = 0
  let t
  try {
    targetRange = targetRange || 1000
    t = trajectory({
      bc: avgBC,
      v0: velocity,
      range: targetRange,
      zeroRange: 100,
      useSpinDrift: false,
      wind: 10,
      windDir: 270
    })
    windMOA = Math.abs(t[targetRange].windMOA)
    dropMOA = Math.abs(t[targetRange].dropMOA)
    const targetVelocity = t[targetRange].velocity

    if (tipCoreLength > 0 && tipStemDiameter > 0) {
      penetration = estimatePenetration(targetVelocity, tipCoreLength)
    }
  } catch (e) {
  }

  const output = {
    diameter,
    drivingBandDiameter,
    drivingBands,
    bearingSurfaceLength,
    jacketThickness,
    noseLength,
    noseCavity,
    noseType,
    baseCavityDiameter,
    baseCavityLength,
    grainsPerCubicIn,
    error,
    dragfunc,
    rtr,
    power,
    haackC,
    C1,
    C2,
    C3,
    C4,
    C5,
    C6,
    G7: smoothG7,
    M,
    BC,
    FF,
    TW,
    SgVsTwist,
    altitude,
    velocity,
    boattailLength,
    baseDiameter,
    tipLength,
    tipStemDiameter,
    tipStemLength,
    tipCoreLength,
    meplat,
    meplatFit,
    length,
    avgBC,
    avgCD,
    avgFF,
    superBC,
    superCD,
    superFF,
    transBC,
    transCD,
    transFF,
    subBC,
    subCD,
    subFF,
    twistRate,
    millerTwistRate,
    mcdragTwistRate,
    hybrid,
    hybridRadius,
    ...weights,
    ...coeffs,
    coeffValues,
    penetration,
    targetRange,
    windMOA,
    dropMOA,
    grains,
    boattailAngle,
    transitionAngle
  }
  return output
}

function calculateWeight({
  diameter,
  length,
  jacketThickness,
  noseLength,
  noseCavity,
  noseType,
  rtr,
  baseCavityDiameter,
  baseCavityLength,
  tipLength,
  tipStemDiameter,
  tipStemLength,
  tipCoreLength,
  power,
  haackC,
  bearingSurfaceLength,
  boattailLength,
  baseDiameter,
  meplat,
  drivingBands,
  drivingBandDiameter,
  grainsPerCubicIn
}) {
  if (rtr === 0) rtr = 0.001
  let bulletRadius = diameter / 2
  let meplatRadius = meplat / 2
  let rise = meplatRadius - bulletRadius
  let run = noseLength
  let m = -run/rise
  let pmx = noseLength / 2
  let pmy = ((bulletRadius - meplatRadius) / 2) + meplatRadius
  let b = pmy - m * pmx
  let tangentRadius = bulletRadius - b
  let radius = tangentRadius / rtr

  // http://mathforum.org/library/drmath/view/53027.html
  let x1 = 0
  let y1 = 0
  let x2 = noseLength
  let y2 = meplatRadius - bulletRadius
  let x3 = x2 / 2
  let y3 = y2 / 2
  let r = radius
  let q = Math.sqrt(Math.pow(x2-x1, 2) + Math.pow(y2-y1, 2))
  let cx = x3 - Math.sqrt(r*r-Math.pow(q/2, 2))*(y1-y2)/q
  let cy = y3 - Math.sqrt(r*r-Math.pow(q/2, 2))*(x2-x1)/q + bulletRadius

  const sliceList = []
  const sliceLength = .001

  let runningTotal = 0
  let x = 0
  let boattailSlices = Math.round(boattailLength / sliceLength)
  const baseRadius = baseDiameter / 2
  for (let i = 0; i < boattailSlices; ++i) {
    let a = baseRadius + (i / boattailSlices) * (bulletRadius - baseRadius)
    let b = baseRadius + ((i + 1) / boattailSlices) * (bulletRadius - baseRadius)
    let v = coneVolume(a, b, boattailLength / boattailSlices, true)

    x += boattailLength / boattailSlices
    runningTotal += v
    sliceList.push([ x, v, runningTotal, a ])
  }

  const bearingSurfaceSlices = Math.round(bearingSurfaceLength / sliceLength)
  for (let i = 0; i < bearingSurfaceSlices; ++i) {
    const r = i < bearingSurfaceSlices / 2 ? (bulletRadius + drivingBandDiameter / 2) : bulletRadius
    const v = Math.PI * r * r * sliceLength
    x += sliceLength
    runningTotal += v
    sliceList.push([ x, v, runningTotal, r ])
    if (isNaN(v)) {
      console.log({ v, x, r })
    }
  }

  let nosePoints = []
  let noseSlices = Math.round(noseLength / sliceLength)
  for (let i = 0; i < noseSlices; ++i) {
    let x1 = i * (noseLength / noseSlices)
    let x2 = (i + 1) * (noseLength / noseSlices)
    let y1
    let y2
    if (noseType === 'haack') {
      y1 = haack(diameter - meplat, noseLength, noseLength - x1) + meplat / 2
      y2 = haack(diameter - meplat, noseLength, noseLength - x2) + meplat / 2
    } else if (noseType === 'ellipse') {
      y1 = ellipseNose(diameter, noseLength, x1)
      y2 = ellipseNose(diameter, noseLength, x2)
    } else if (noseType === 'power') {
      y1 = powerNose(diameter, noseLength, noseLength - x1, power)
      y2 = powerNose(diameter, noseLength, noseLength - x2, power)
    } else {
      y1 = Math.sqrt(radius * radius - (x1 - cx) * (x1 - cx)) + cy
      y2 = Math.sqrt(radius * radius - (x2 - cx) * (x2 - cx)) + cy
    }
    let v = coneVolume(y1, y2, noseLength / noseSlices, true)
    //let v = Math.PI * y2 * y2 * sliceLength
    x += noseLength / noseSlices
    runningTotal += v
    sliceList.push([ x, v, runningTotal, y1 ])
    if (i > 0 && i % 2 === 0) {
      nosePoints.push([ x1, y1 ])
    }
  }

  let CG
  let Iy
  let Ix
  let mass
  let maxTipDiameter = 0
  if (jacketThickness > 0) {
    const cavityStart = length - noseCavity
    const radiusSlicesCm = sliceList.map(v => v[3] * 2.54)
    const radiusSlicesCmJacketInner = sliceList.map(v => v[0] < jacketThickness ? 0 : Math.max(0, v[3] - jacketThickness) * 2.54)
    const radiusSlicesCmCore =        sliceList.map(v => (v[0] < cavityStart && v[0] > jacketThickness) ? Math.max(0, v[3] - jacketThickness) * 2.54 : 0)
    const radiusSlicesZero = sliceList.map(() => 0)
    CG =
      calculateCenterOfGravity([ radiusSlicesCm, radiusSlicesCmCore ], [ radiusSlicesCmJacketInner, radiusSlicesZero ], [ 8.94, 11.34 ], sliceLength * 2.54) / 2.54
    mass =
      calculateTotalWeight(radiusSlicesCm, radiusSlicesCmJacketInner, 8.94, sliceLength * 2.54) +
      calculateTotalWeight(radiusSlicesCmCore, radiusSlicesZero, 11.34, sliceLength * 2.54)
    Ix =
      calculatePolarMomentOfInertia(radiusSlicesCm, radiusSlicesCmJacketInner, 8.94, sliceLength * 2.54) +
      calculatePolarMomentOfInertia(radiusSlicesCmCore, radiusSlicesZero, 11.34, sliceLength * 2.54)
    Iy =
      calculateTransverseMomentOfInertia(radiusSlicesCm, radiusSlicesCmJacketInner, 8.94, sliceLength * 2.54, CG * 2.54) +
      calculateTransverseMomentOfInertia(radiusSlicesCmCore, radiusSlicesZero, 11.34, sliceLength * 2.54, CG * 2.54)
  } else {
    const radiusSlicesCm = sliceList.map(v => {
      if (isNaN(v[3])) {
        console.log(v)
      }
      if (v[0] > length - tipLength) {
        return 0
      }
      return v[3] * 2.54
    })
    sliceList.map(v => {
      if (v[0] > length - tipLength) {
        maxTipDiameter = Math.max(maxTipDiameter, v[3] * 2)
      }
    })
    //console.log({ maxTipDiameter })
    if (maxTipDiameter < tipStemDiameter) {
      tipStemDiameter = maxTipDiameter
    }
    const tipSlicesCm = sliceList.map(v => {
      if (v[0] > length - tipLength) {
        return v[3] * 2.54
      } else if (v[0] > length - tipLength - tipStemLength) {
        return tipStemDiameter / 2 * 2.54
      }
      return 0
    })
    const tipSlicesZero = sliceList.map(() => 0)
    const radiusSlicesInner = sliceList.map(v => {
      if (baseCavityLength > 0 && baseCavityDiameter > 0 && v[0] < baseCavityLength) {
        return (baseCavityDiameter / 2) * 2.54
      }
      if (v[0] > length - tipLength) {
        return 0
      }
      if (v[0] > length - tipLength - tipStemLength - tipCoreLength) {
        return tipStemDiameter / 2 * 2.54
      }
      return 0
    })
    const tipCoreSlices = sliceList.map(v => {
      if (
        v[0] > length - tipLength - tipStemLength - tipCoreLength &&
        v[0] < length - tipLength - tipStemLength
      ) {
        return (tipStemDiameter / 2) * 2.54

      }
      return 0
    })
    //const tipDensity = 1.41
    const tipDensity = 2.7
    //const tipDensity = 19.25
    //const coreDensity = 11.34
    const coreDensity = 19.25
    CG = calculateCenterOfGravity(
      [ radiusSlicesCm, tipSlicesCm, tipCoreSlices ],
      [ radiusSlicesInner, tipSlicesZero, tipSlicesZero ],
      [ 8.94, tipDensity, coreDensity ],
      sliceLength * 2.54
    ) / 2.54
    mass =
      calculateTotalWeight(radiusSlicesCm, radiusSlicesInner, 8.94, sliceLength * 2.54) +
      calculateTotalWeight(tipSlicesCm, tipSlicesZero, tipDensity, sliceLength * 2.54) +
      calculateTotalWeight(tipCoreSlices, tipSlicesZero, coreDensity, sliceLength * 2.54)
    Ix =
      calculatePolarMomentOfInertia(radiusSlicesCm, radiusSlicesInner, 8.94, sliceLength * 2.54) +
      calculatePolarMomentOfInertia(tipSlicesCm, tipSlicesZero, tipDensity, sliceLength * 2.54) +
      calculatePolarMomentOfInertia(tipCoreSlices, tipSlicesZero, coreDensity, sliceLength * 2.54)
    Iy =
      calculateTransverseMomentOfInertia(radiusSlicesCm, radiusSlicesInner, 8.94, sliceLength * 2.54, CG * 2.54) +
      calculateTransverseMomentOfInertia(tipSlicesCm, tipSlicesZero, tipDensity, sliceLength * 2.54, CG * 2.54) +
      calculateTransverseMomentOfInertia(tipCoreSlices, tipSlicesZero, coreDensity, sliceLength * 2.54, CG * 2.54)
    if (isNaN(Ix)) {
      console.log({ radiusSlicesCm, radiusSlicesInner, tipSlicesCm })
    }
  }
  if (isNaN(CG)) {
    console.log({ sliceList })
  }

  const cgPercent = 100 * (CG + bearingSurfaceLength + boattailLength) / length

  return {
    grains: mass * 15.4324,
    nosePoints,
    CG,
    Iy,
    Ix,
    cgPercent,
    maxTipDiameter,
    centerX: cx,
    centerY: cy,
    radiusInches: radius,
    tangentRadius,
    radiusCalibers: radius / diameter
  }
}

//function calculateCenterOfGravity(diameters, thickness) {
//  let totalMass = 0;
//  let totalMoment = 0;
//
//  for (let i = 0; i < diameters.length; i++) {
//    let radius = diameters[i] / 2;
//    let mass = Math.PI * Math.pow(radius, 2) * thickness;
//    let height = (i + 0.5) * thickness; // Center of each disc
//    totalMass += mass;
//    totalMoment += mass * height;
//  }
//
//  let centerOfGravity = totalMoment / totalMass;
//  return centerOfGravity;
//}
function calculateCenterOfGravity(outerRadiusArrays, innerRadiusArrays, densities, thickness) {
  let totalMass = 0;
  let weightedPositionSum = 0;

  for (let i = 0; i < outerRadiusArrays.length; i++) {
    let outerRadii = outerRadiusArrays[i];
    let innerRadii = innerRadiusArrays[i];
    let density = densities[i];

    for (let j = 0; j < outerRadii.length; j++) {
      let outerRadius = outerRadii[j];
      let innerRadius = innerRadii[j];

      // Calculating the volume and mass of the current disc
      let volume = Math.PI * (outerRadius * outerRadius - innerRadius * innerRadius) * thickness;
      let mass = density * volume;

      // Position of the center of the disc in the stack
      let position = (j * thickness) + (thickness / 2);

      // Updating total mass and weighted position sum
      totalMass += mass;
      weightedPositionSum += position * mass;
    }
  }

  if (totalMass === 0) {
    return null; // Avoid division by zero if the total mass is zero
  }

  // Calculating the center of gravity
  let centerOfGravity = weightedPositionSum / totalMass;
  return centerOfGravity;
}


function altitudeFeetTokPa(altitudeFeet) {
  const seaLevelPressureKpa = 10.1325; // standard sea level pressure in kPa
  const scaleHeight = 8434.5; // scale height in feet
  const altitudeMeters = altitudeFeet * 0.3048;
  let pressureKpa = seaLevelPressureKpa * Math.exp(-altitudeMeters / scaleHeight);

  return pressureKpa;
}

export function getStaticStability (diameter, twistRate, Cma, Iy, Ix, fps, altitude) {
  const airDensity = altitudeFeetTokPa(altitude)
  const meterDiameter = diameter * 2.54
  const Vm = fps * .3048
  const spinRate = calculateSpinRateRadians(fps, twistRate)
  const sg = calculateGyroscopicStability(Ix, spinRate, airDensity, Iy, Cma, meterDiameter, Vm)
  return sg
}

function estimateCmaFromMiller (diameter, length, grains, velocity, altitude, Iy, Ix) {
  let bestCma
  let bestError = Math.min()
  for (let Cma = 0; Cma < 5; Cma += .01) {
    const millerTwistRate = neededTwist(diameter, length, grains, velocity / 1245, 0, 1.5)
    let sg = getStaticStability(diameter, millerTwistRate, Cma, Iy, Ix, velocity, 0)
    let error = Math.abs(1.5 - sg)
    if (error < bestError) {
      bestError = error
      bestCma = Cma
    }
  }
  return bestCma
}

function calculateSpinRateRadians(velocityFps, twistRateInches) {
  const velocityIps = velocityFps * 12; // Convert velocity to inches per second
  const revolutionsPerSecond = velocityIps / twistRateInches; // Get revolutions per second
  const spinRateRadians = revolutionsPerSecond * 2 * Math.PI; // Convert to radians per second
  return spinRateRadians;
}

function calculateGyroscopicStability(Ix, spinRateRadians, rho0, Iy, Cma, d, Vm) {
  const pi = Math.PI; // Pi constant
  const numerator = 2 * Math.pow(Ix, 2) * Math.pow(spinRateRadians, 2);
  const denominator = pi * rho0 * Iy * Cma * Math.pow(d, 3) * Math.pow(Vm, 2);
  // Calculate Sg0 (gyroscopic stability factor at the muzzle)
  const Sg0 = numerator / denominator;

  return Sg0;
}

function calculateDynamicStability(Ix, Iy, m, d, Cla, Cd, Cnpa, Cmq, Sg) {
  const k1 = (m * d ** 2) / Ix
  const k2 = (m * d ** 2) / Iy
  const Sd = (2 * (Cla + k1 * Cnpa)) / (Cla - Cd - k2 * Cmq)
  const minSg = 1 / (Sd * (2 - Sd))
  const stable = Sd > 0 && Sd < 2 && Sg >= minSg && Sg > 1
  return { Sd, minSg, stable }
}

function calculateTransverseMomentOfInertia(outerRadiusArray, innerRadiusArray, density, thickness, centerOfGravity) {
  let totalMoment = 0;

  for (let i = 0; i < outerRadiusArray.length; i++) {
    let outerRadius = outerRadiusArray[i];
    let innerRadius = innerRadiusArray[i];

    // Calculating the volume of the hollow cylinder (disc)
    let volume = Math.PI * (outerRadius * outerRadius - innerRadius * innerRadius) * thickness;

    let mass = density * volume;
    let distanceFromBase = i * thickness;
    let distanceFromCenter = distanceFromBase - centerOfGravity;

    // Transverse moment of inertia for a hollow cylinder (annular section)
    let segmentMoment = mass * (outerRadius * outerRadius + innerRadius * innerRadius) / 4;

    // Using the parallel axis theorem to shift to the center of gravity
    let shiftedMoment = segmentMoment + mass * distanceFromCenter * distanceFromCenter;
    totalMoment += shiftedMoment;
  }

  return totalMoment;
}

//function calculateTransverseMomentOfInertia(radiusArray, density, thickness, centerOfGravity) {
//  let totalMoment = 0;
//
//  // Calculate the moment of inertia for each segment
//  for (let i = 0; i < radiusArray.length; i++) {
//    let radius = radiusArray[i];
//    let volume = Math.PI * radius * radius * thickness;
//    let mass = density * volume;
//    let distanceFromBase = i * thickness
//    let distanceFromCenter = distanceFromBase - centerOfGravity
//    let segmentMoment = (mass * radius * radius) / 4
//    // Using the parallel axis theorem to shift to the center of gravity
//    let shiftedMoment = segmentMoment + mass * distanceFromCenter * distanceFromCenter;
//    totalMoment += shiftedMoment;
//  }
//
//  return totalMoment;
//}

function calculateTotalWeight(outerRadiusArray, innerRadiusArray, density, thickness) {
  let totalWeight = 0;

  for (let i = 0; i < outerRadiusArray.length; i++) {
    let outerRadius = outerRadiusArray[i];
    let innerRadius = innerRadiusArray[i];

    // Calculating the volume of the hollow cylinder (disc)
    let volume = Math.PI * (outerRadius * outerRadius - innerRadius * innerRadius) * thickness;

    // Mass (weight) calculation
    let mass = density * volume;
    totalWeight += mass;
  }

  // Assuming the density is given in weight per unit volume (e.g., lb/ft^3),
  // the totalWeight will be in pounds.
  return totalWeight;
}

function calculatePolarMomentOfInertia(outerRadiusArray, innerRadiusArray, density, thickness) {
  let totalPolarMoment = 0
  let totalMass = 0

  for (let i = 0; i < outerRadiusArray.length; i++) {
    let outerRadius = outerRadiusArray[i];
    let innerRadius = innerRadiusArray[i];

    // Calculating the volume of the hollow cylinder (disc)
    let volume = Math.PI * (outerRadius * outerRadius - innerRadius * innerRadius) * thickness;

    let mass = density * volume;

    // Polar moment of inertia for a hollow cylinder
    let polarMoment = 0.5 * mass * (outerRadius * outerRadius + innerRadius * innerRadius);
    totalPolarMoment += polarMoment;
    totalMass += mass
  }

  return totalPolarMoment;
}

//function calculatePolarMomentOfInertia(radiusArray, density, thickness) {
//  let totalPolarMoment = 0;
//
//  for (let i = 0; i < radiusArray.length; i++) {
//    let radius = radiusArray[i];
//    let volume = Math.PI * radius * radius * thickness;
//    let mass = density * volume;
//
//    let polarMoment = 0.5 * mass * radius * radius;
//    totalPolarMoment += polarMoment;
//  }
//
//  return totalPolarMoment
//}

function coneVolume(R, r, h) {
  let v = ((Math.PI * h) / 3) * (R * R + R * r + r * r)
  return v
}

function neededTwist (diameter, length, grains, mach = null, altitude = null, sg = 1.5) {
  let correction = 1
  if (mach) {
    correction = Math.pow((mach * 1245) / 2800, .3333)
  }
  if (altitude) {
    correction = correction * Math.pow(Math.E, 3.158e-5 * altitude)
  }
  sg /= correction
  let calibersLength = length / diameter
  let calibersPerTurn = Math.sqrt(30 * grains / (sg * Math.pow(diameter, 3) * calibersLength * (1 + Math.pow(calibersLength, 2))))
  let twistRate = calibersPerTurn * diameter
  return twistRate
}

function mcdrag_twist(mach, diameter, bearingSurfaceLength, noseLength, rtr, boattailLength, baseDiameter, meplat, grainsPerCubicIn) {
  // dmp = meplat
  // dba = baseDiameter
  // rtr
  // nsl = noseLength
  // dia = diameter
  // spg = specific gravity
  // tln = total length
  // twt = twist
  const totalLength = boattailLength + bearingSurfaceLength + noseLength
  const specificGravity = grainsPerCubicIn / 249
  const twist = 7
  let a, a1, b, b1, s1, s2, g1;
  let gt, m2, stability;
  m2 = mach*mach;
  s1 = Math.sqrt(1.0 - meplat);
  s2 = 1.0 - Math.pow(baseDiameter, 2);
  if (mach <= 0.95)
    g1 = 20.082 + 3.726*(mach/Math.sqrt(1.0 - m2));
  else if (mach >= 1.1)
    g1 = 35.079 - 24.066*(Math.sqrt(m2 - 1.0)/mach);
  else
    g1 = 71.73001 - 42.433*mach;
  a1 = g1*s2;
  if (mach < 1.0)
  {
    b1 = Math.sqrt(1.0 - m2);
    b = 0.82112 + 0.36971*b1;
    a = 34.779 + (24.091 + (8.977  + rtr*(-12.804 + 8.38*rtr))*noseLength)*s1*b1 - a1;
  }
  else
  {
    b1 = Math.sqrt(m2 - 1.0)/mach;
    b = 1.0528 + 0.23379*b1 - 0.004884*(mach - 1.0);
    a = 58.873 + (8.115 + (14.15  + rtr*(-15.348 + 7.216*rtr))*noseLength)*s1*b1*b1 - a1;
  }
  gt = diameter*a*Math.sqrt(specificGravity)/Math.pow(totalLength, b);
  if (twist != 0.0)
    stability = 1.5*Math.pow(gt/twist, 2);
  else
    stability = 0.0;

  return gt * diameter
}

function getG7ScalingFactors (M, G7) {
  const scalingFactors = []
  for (let i = 0; i < M.length; ++i) {
    const interp = linearInterpolate(actualG7_M, actualG7, M[i])
    scalingFactors.push(G7[i] / interp)
  }
  return scalingFactors
}

function linearInterpolate(X, Y, x) {
    if (X.length !== Y.length) {
        throw new Error("X and Y arrays must be of the same length");
    }

    for (let i = 0; i < X.length - 1; i++) {
        if (x >= X[i] && x <= X[i + 1]) {
            // Perform linear interpolation
            const slope = (Y[i + 1] - Y[i]) / (X[i + 1] - X[i]);
            return Y[i] + slope * (x - X[i]);
        }
    }

    throw new Error("Interpolation point x is out of range");
}

function gaussianKernel(size, sigma) {
    const kernel = Array(size).fill(0);
    let sum = 0;
    const half = Math.floor(size / 2);
    for (let i = 0; i < size; i++) {
        kernel[i] = Math.exp(-0.5 * Math.pow((i - half) / sigma, 2));
        sum += kernel[i];
    }
    // Normalize the kernel
    return kernel.map(val => val / sum);
}

function gaussianFilter(data, kernelSize, sigma) {
    const kernel = gaussianKernel(kernelSize, sigma);
    const halfKernel = Math.floor(kernelSize / 2);
    const filteredData = [];

    for (let i = 0; i < data.length; i++) {
        let sum = 0;
        for (let j = 0; j < kernelSize; j++) {
            const idx = i + j - halfKernel;
            sum += (idx >= 0 && idx < data.length) ? data[idx] * kernel[j] : 0;
        }
        filteredData.push(sum);
    }

    return filteredData;
}

function padData(data, halfKernel) {
      const start = data.slice(0, halfKernel).reverse();
      const end = data.slice(-halfKernel).reverse();
      return [...start, ...data, ...end];
}

function gaussianFilterWithPadding(data, kernelSize, sigma) {
      const halfKernel = Math.floor(kernelSize / 2);
      const paddedData = padData(data, halfKernel);
      return gaussianFilter(paddedData, kernelSize, sigma).slice(halfKernel, -halfKernel);
}

function jumpEquation(
  Cna,
  Cd,
  Cma,
  Iy,
  Ix,
  grains,
  diameter,
  velocity,
  tubeAngle,
  twistRate,
  deltaCg
) {
  const refDiameter = diameter * 2.54
  const spinRate = calculateSpinRateRadians(velocity, twistRate)
  const Vm = velocity * .3048 * 100
  const mass = grains * 0.0647989
  const tubleAngleRadians = tubeAngle * Math.PI / 180;

  const aero = (Cna - Cd) / Cma
  const massProp = (Iy - Ix) / (mass * (refDiameter ** 2))
  const scale = refDiameter / Vm
  const angular = tubleAngleRadians * spinRate
  const crossVelocity = deltaCg * (spinRate / Vm)

  const thetaJ = (aero * massProp * scale * angular) + crossVelocity
  return thetaJ
}

function calculateInBoreAngle (bulletDiameter, bearingSurfaceLength, freeboreDiameter) {
    const deltaD = freeboreDiameter - bulletDiameter;
    const deltaR = deltaD / 2;
    const sinTheta = deltaR / bearingSurfaceLength;
    const thetaRadians = Math.asin(sinTheta);
    const thetaDegrees = thetaRadians * (180 / Math.PI);
    return thetaDegrees;
}
